module.exports = {
  mobile: "mobile",
  portal: "portal",
  externalService: "externalService",
  web: "web",
  hotel: "hotel",
};
